export let langTypes = [
    {
        text: "中文简体",
        value: "zh-CN",
        cnName: "中文简体",
    },
    {
        text: "English",
        value: "en-US",
        cnName: "英语",
    },
    {
        text: "中文繁體",
        value: "zh-TW",
        cnName: "中文繁体",
    },
    {
        text: "日本語",
        value: "ja-JP",
        cnName: "日语",
    },
    {
        text: "español",
        value: "es-ES",
        cnName: "西班牙语",
    },
    {
        text: "português",
        value: "pt-PT",
        cnName: "葡萄牙语",
    },
    {
        text: "Deutsch",
        value: "de-DE",
        cnName: "德语",
    },
    {
        text: "français",
        value: "fr-FR",
        cnName: "法语",
    },
    {
        text: "italiano",
        value: "it-IT",
        cnName: "意大利语",
    },
    {
        text: "Türkçe",
        value: "tr-TR",
        cnName: "土耳其语",
    },
    {
        text: "العربية",
        value: "ar-AE",
        cnName: "阿拉伯语",
    },
    {
        text: "Indonesia",
        value: "in-ID",
        cnName: "印尼语",
    },
    {
        text: "ไทย",
        value: "th-TH",
        cnName: "泰语",
    },
    {
        text: "Tiếng Việt",
        value: "vi-VN",
        cnName: "越南语",
    },
    {
        text: "русский",
        value: "ru-RU",
        cnName: "俄语",
    },
    {
        text: "한국어",
        value: "ko-KR",
        cnName: "韩语",
    },
    {
        text: "polski",
        value: "pl-PL",
        cnName: "波兰语",
    },
    {
        text: "Melayu",
        value: "ms-MY",
        cnName: "马来语",
    },
    {
        text: "O'zbekcha",
        value: "uz-UZ",
        cnName: "乌兹别克语",
    },
    {
        text: "Nederlands",
        value: "nl-NL",
        cnName: "荷兰语",
    },
    {
        text: "svenska",
        value: "sv-SE",
        cnName: "瑞典语",
    },
    {
        text: "suomi",
        value: "fi-FI",
        cnName: "芬兰语",
    },
    {
        text: "Dansk",
        value: "da-DK",
        cnName: "丹麦语",
    },
    {
        text: "norsk",
        value: "nb-NO",
        cnName: "挪威语",
    },
    {
        text: "Ελληνικά",
        value: "el-GR",
        cnName: "希腊语",
    },
    {
        text: "Magyar",
        value: "hu-HU",
        cnName: "匈牙利语",
    },
    {
        text: "български",
        value: "bg-BG",
        cnName: "保加利亚语",
    },
    {
        text: "Română",
        value: "ro-RO",
        cnName: "罗马尼亚语",
    },
    {
        text: "čeština",
        value: "cs-CZ",
        cnName: "捷克语",
    },
    {
        text: "slovenčina",
        value: "sk-SK",
        cnName: "斯洛伐克语",
    },
    {
        text: "slovenščina",
        value: "sl-SI",
        cnName: "斯洛文尼亚语",
    },
    {
        text: "shqip",
        value: "sq-AL",
        cnName: "阿尔巴尼亚语",
    },
    {
        text: "hrvatski",
        value: "hr-HR",
        cnName: "克罗地亚语",
    },
    {
        text: "Lietuvių",
        value: "lt-LT",
        cnName: "立陶宛语",
    },
    {
        text: "Latviešu",
        value: "lv-LV",
        cnName: "拉脱维亚语",
    },
    {
        text: "eesti keel",
        value: "et-EE",
        cnName: "爱沙尼亚语",
    },
    {
        text: "Íslenska",
        value: "is-IS",
        cnName: "冰岛语",
    },
    {
        text: "ខ្មែរ",
        value: "km-KH",
        cnName: "高棉语",
    },
    {
        text: "ລາວ",
        value: "lo-LA",
        cnName: "老挝语",
    },
]